(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('video-carousel')) {
    class VideoCarousel extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-vc-track]');
        this.prevButton = this.querySelector('[data-vc-prev]');
        this.nextButton = this.querySelector('[data-vc-next]');
        this.videos = Array.from(this.querySelectorAll('video'));
        this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        this.videos.forEach((video) => {
          video.muted = true;
          video.loop = true;
          video.playsInline = true;
          if (this.reduceMotion) {
            video.controls = true;
          } else {
            video.controls = false;
            video.removeAttribute('controls');
          }
        });
        this.classList.toggle('vc--reduced', this.reduceMotion);

        this.prevButton?.addEventListener('click', () => this.scrollPage(-1));
        this.nextButton?.addEventListener('click', () => this.scrollPage(1));
        this.onScroll = () => this.updateArrows();
        this.onResize = () => this.updateArrows();
        this.track.addEventListener('scroll', this.onScroll, { passive: true });
        window.addEventListener('resize', this.onResize);
        this.updateArrows();

        this.querySelectorAll('[data-vc-sound]').forEach((button) => {
          button.addEventListener('click', (event) => this.toggleSound(event, button));
        });

        if (!this.reduceMotion && 'IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                const video = entry.target;
                if (entry.isIntersecting) {
                  video.play().catch(() => {});
                } else {
                  video.pause();
                }
              });
            },
            { threshold: 0.6 }
          );
          this.videos.forEach((video) => this.observer.observe(video));
        }
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        window.removeEventListener('resize', this.onResize);
      }

      scrollPage(direction) {
        this.track.scrollBy({ left: direction * this.track.clientWidth * 0.9, behavior: 'smooth' });
      }

      updateArrows() {
        if (!this.track) return;
        const maxScroll = this.track.scrollWidth - this.track.clientWidth - 2;
        if (this.prevButton) this.prevButton.disabled = this.track.scrollLeft <= 2;
        if (this.nextButton) this.nextButton.disabled = this.track.scrollLeft >= maxScroll;
        this.classList.toggle('vc--static', maxScroll <= 0);
      }

      toggleSound(event, button) {
        event.preventDefault();
        event.stopPropagation();
        const video = button.closest('.vc__media').querySelector('video');
        if (!video) return;
        const turnOn = video.muted;

        this.videos.forEach((other) => {
          other.muted = true;
        });
        this.querySelectorAll('[data-vc-sound]').forEach((other) => {
          other.setAttribute('aria-pressed', 'false');
          other.setAttribute('aria-label', 'Turn sound on');
        });

        if (turnOn) {
          video.muted = false;
          video.play().catch(() => {});
          button.setAttribute('aria-pressed', 'true');
          button.setAttribute('aria-label', 'Turn sound off');
        }
      }
    }

    customElements.define('video-carousel', VideoCarousel);
  }

  } catch(e) { console.error(e); }
})();
})();
